import { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { useSelector } from 'react-redux';
import history from 'utils/history';

import DocumentationOptionTabs from './DocumentationOptionTabs/index';
import CongratulationsModalHeader from './CongratulationsModalHeader/index';
import CongratulationsModalFooter from './CongratulationsModalFooter/index';

import { getJobDetailPageUrl } from 'utils/redirects';
import { openZohoSalesIqChat } from 'utils/common';
import { sendAmplitudeEvents } from 'utils/common';
import { EventNames } from 'utils/events';

import './index.css';

const CongratulationsModal = () => {
  let setting = useSelector((state) => state.appSetting?.setting);
  const USERFLOW_TOKEN = 'c5fc7c37-b640-4b71-9aa0-d16ee3a555ac';

  let jobList = useSelector(
    (state) => state.hypertestJobList?.hypertestJobList?.data?.data
  );
  function handleContinueTour() {
    if (window.userflow) {
      window.userflow.start(USERFLOW_TOKEN);
    }

    sendAmplitudeEvents(EventNames.HYP_CONTINUE_TOUR_MODAL);
    const url = jobList?.length
      ? getJobDetailPageUrl(jobList[jobList.length - 1]?.id)
      : '';
    handleModalClosure();
    url && history.push(url);
  }
  function handleTalkToExpert() {
    sendAmplitudeEvents(EventNames.HYP_TALK_TO_EXPERT_MODAL);
    openZohoSalesIqChat();
  }
  function handleSkip() {
    sendAmplitudeEvents(EventNames.HYP_SKIP_FOR_NOW_MODAL);
    handleModalClosure();
  }

  function handleContinueTesting() {
    sendAmplitudeEvents(EventNames.HYP_CONTINUE_TESTING_MODAL);
    handleModalClosure();
  }
  /**
   * adding this so that modal is always in dom, and
   * userflow can toggle the visibility as needed
   *
   */
  function handleModalClosure() {
    document
      .querySelector('.congratulation-modal-container')
      ?.classList.remove('congratulation-modal-container-visible');
  }

  return (
    <Transition
      appear
      show={true}
      as={Fragment}
      className="congratulation-modal-container"
    >
      <Dialog
        className={`congratulation-modal-dialog ${
          setting.promoBannerHeight > 0 ? 'modalSidebarBannerPadding' : ''
        }`}
        open={true}
        onClose={() => {
          handleModalClosure();
        }}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Dialog.Overlay className="ltw-fixed ltw-inset-0 ltw-bg-black-darkest ltw-opacity-60" />
        </Transition.Child>
        <div className="congratulation-modal-content-wrapper">
          <div className="congratulation-modal-content">
            <CongratulationsModalHeader />
            <DocumentationOptionTabs />
            <CongratulationsModalFooter
              handleContinueTour={handleContinueTour}
              handleTalkToExpert={handleTalkToExpert}
              handleSkip={handleSkip}
              handleContinueTesting={handleContinueTesting}
            />
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default CongratulationsModal;
